import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    if (location.pathname !== '/') {
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        element?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const element = document.getElementById(id);
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const textColor = isScrolled ? 'text-charcoal' : 'text-charcoal';
  const hoverColor = isScrolled ? 'hover:text-gray-medium' : 'hover:text-gray-medium';

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/72f6c186dba6e85b29149b12cdad4e19/8634dd506c02412618be9c7eeb5f8b42.png" 
              alt="NEXIT New Media" 
              className="h-12 w-auto transition-all duration-300"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm ${textColor} ${hoverColor} transition-colors cursor-pointer whitespace-nowrap`}
            >
              Hizmetler
            </button>
            <button
              onClick={() => scrollToSection('works')}
              className={`text-sm ${textColor} ${hoverColor} transition-colors cursor-pointer whitespace-nowrap`}
            >
              İşler
            </button>
            <button
              onClick={() => scrollToSection('process')}
              className={`text-sm ${textColor} ${hoverColor} transition-colors cursor-pointer whitespace-nowrap`}
            >
              Süreç
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm ${textColor} ${hoverColor} transition-colors cursor-pointer whitespace-nowrap`}
            >
              İletişim
            </button>
          </div>

          {/* CTA Button */}
          <button
            onClick={() => scrollToSection('contact')}
            className={`hidden lg:block px-6 py-2.5 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
              isScrolled
                ? 'bg-charcoal text-white hover:bg-charcoal/90'
                : 'bg-charcoal text-white hover:bg-charcoal/90'
            }`}
          >
            Brief Gönder
          </button>

          {/* Mobile Menu Button */}
          <button className={`lg:hidden ${textColor} w-6 h-6 flex items-center justify-center cursor-pointer`}>
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </motion.nav>
  );
}
